import * as React from 'react'

import {makeEditable} from '@/common/utils'
import {Grid} from '@/components/Grid'

const ArcadeEmbed = ({arcadeLink, _editable}) => {
  return (
    <section {...makeEditable(_editable)} className='w-full py-12'>
      <Grid>
        <div className='col-span-full'>
          {arcadeLink && (
            <iframe
              src={arcadeLink}
              className='aspect-[16/9] w-full'
              title='MIA'
              frameborder='0'
              loading='lazy'
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              allow='clipboard-write'
            ></iframe>
          )}
        </div>
      </Grid>
    </section>
  )
}

export default ArcadeEmbed
